export default {"src":"/_next/static/media/28-icon.669e20eb.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};